// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectionList-module--container--1JxTn","title":"CollectionList-module--title--3nFee","item":"CollectionList-module--item--D_yJd"};